import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../../components/shared/utility';

const initialState = {
    dataFormDialogOpen: false,
    alertDialogOpen: false
};

const onDataFormDialogOpen = (state, action) => {
    return updateObject(state, {
        dataFormDialogOpen: true
    })
};

const onDataFormDialogClose = (state, action) => {
    return updateObject(state, {
        dataFormDialogOpen: false
    })
};

const onAlertDialogOpen = (state, action) => {
    return updateObject(state, {
        alertDialogOpen: true
    })
};

const onAlertDialogClose = (state, action) => {
    return updateObject(state, {
        alertDialogOpen: false
    })
};

export default (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.DATA_FORM_DIALOG_OPEN:
            return onDataFormDialogOpen(state, action);
        case actionTypes.REQUEST_DATA_FORM_DIALOG_CLOSE:
            return onDataFormDialogClose(state, action);
        case actionTypes.ALERT_DIALOG_OPEN:
            return onAlertDialogOpen(state, action);
        case actionTypes.REQUEST_ALERT_DIALOG_CLOSE:
            return onAlertDialogClose(state, action)
        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/store/reducers/modalReducer.js